let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1oL5z")).then(() => parcelRequire('3WUNe'));